import React from 'react'
import { TableCell, TableRow } from '@mui/material'

const UserContactedRow = ({row}) => {
  return (
    <TableRow
    key={row?._id}
    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
  >
    {/* <TableCell>{index + 1}</TableCell> */}
    <TableCell>{row?.name || "-"}</TableCell>
    <TableCell>{row?.email || "-"}</TableCell>
    <TableCell>{row?.phone || "-"}</TableCell>
    <TableCell sx={{whiteSpace:'nowrap'}}>{row?.message || "-"}</TableCell>
    <TableCell>
      {new Date(row?.createdAt || "-").toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })}
    </TableCell>
  </TableRow>
  )
}

export default UserContactedRow